/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ContactTermsReceivables, CostCenterRestService, SystemVarsRestService } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { AutocompleteItem, withDisplayAsNameAndDescription } from '@gh/common-shared-data';
import { FilteredDataQuery, getSlicedData } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import {
  SystemVarsReceivables,
  systemVarsReceivablesFromDto,
  systemVarsReceivablesToDto,
} from './model/system-vars.model';

@Injectable()
export class SystemVarsReceivablesTabBusinessService implements InitViewService {
  constructor(private systemVarsRest: SystemVarsRestService,
              private costCenterRest: CostCenterRestService,
              private dictionaryService: DictionaryService) {
  }

  initView(): any {
    return {
      details: this.get(),
      termsReceivables: this.dictionaryService.getByEnum(ContactTermsReceivables),
    };
  }

  get(): Observable<SystemVarsReceivables> {
    return this.systemVarsRest.getReceivables().pipe(map$(systemVarsReceivablesFromDto));
  }

  update(receivables: SystemVarsReceivables): Observable<SystemVarsReceivables> {
    return this.systemVarsRest.updateReceivables(systemVarsReceivablesToDto(receivables)).pipe(
      map$(systemVarsReceivablesFromDto));
  }

  findCostCentersByName(query: FilteredDataQuery<string>,
                        startFromCode?: number): Observable<AutocompleteItem[]> {
    return this.costCenterRest.findAllAutocompleteItemsAsDataSource({
        searchString: query.filter,
        autocomplete: true,
        fromCode: startFromCode,
      })
      .select(query).pipe(
        map$(getSlicedData),
        map$((costCenters) => costCenters.map(withDisplayAsNameAndDescription)));
  }
}
